const FUNERAL_CLAIM_TYPES = [
  { label: 'Accidental Death', value: 'ACCIDENT' },
  { label: 'Death by Natural Causes', value: 'NATURAL' },
  { label: 'Suicide', value: 'SUICIDE' },
  { label: 'Stillborn', value: 'STILLBORN' },
]

export default FUNERAL_CLAIM_TYPES
